/**
 * Runtime target detection.
 * `Platform.OS === 'web'` is only true under react-native-web (PWA).
 * Native iOS/Android never take web branches — zero UI/behavior change there.
 */
import { Platform } from 'react-native';

export function isWebRuntime(): boolean {
  return Platform.OS === 'web';
}
